import { createContext, type PropsWithChildren, use, useMemo } from 'react';
import type { Interaction } from '../../util/interaction';

export type RowLevelInteractionBuilder<T extends object> = (row: T | undefined) => Interaction | undefined;

const TableRowContext = createContext<{ rowLevelInteraction?: Interaction }>({
  rowLevelInteraction: undefined,
});

interface TableRowContextProviderProps {
  rowLevelInteraction?: Interaction;
}

export function TableRowContextProvider({ children, rowLevelInteraction }: PropsWithChildren<TableRowContextProviderProps>) {
  const value = useMemo(() => ({ rowLevelInteraction }), [rowLevelInteraction]);

  return <TableRowContext.Provider value={value}>{children}</TableRowContext.Provider>;
}

export function useTableRowContext() {
  return use(TableRowContext);
}
